module.exports = __webpack_public_path__ + "static/media/gamesPlayed_500_1000.c52855f3.png";